import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_FACEBOOK_AD_CREATIVE = gql`
  mutation CreateAdCreativeMutation($fields: Map!, $user_socmed_id: String!) {
    CreateFacebookAdCreative(fields: $fields, user_socmed_id: $user_socmed_id) {
      data
    }
  }
`;
